import PropTypes from "prop-types";

import { FormControl, InputLabel, Input } from "@mui/material";

import Clear from "@mui/icons-material/Clear.js";
import Check from "@mui/icons-material/Check";

// core components
import stylesFunction from "../../assets/jss/material-dashboard-react/components/customInputStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle";


export default function CustomInput(props) {
    const styles = stylesFunction();

    const { formControlProps, labelText, id, labelProps, inputProps, error, success } = props;

    const labelData = {
        "labelRootError": error,
        "labelRootSuccess": success && !error
    };
    const labelKeys = getKeyArray(labelData);

    const underlineData = {
        "underlineError": error,
        "underlineSuccess": success && !error,
        "underline": true
    };
    const underlineKeys = getKeyArray(underlineData);

    return (
        <FormControl
            {...formControlProps}
            sx={getBaseSxStyle(styles, ['formControl'])}
        >
            {
                labelText !== undefined
                    ? (<InputLabel
                        {...labelProps}
                        sx={getBaseSxStyle(styles, ['labelRoot', ...labelKeys])}
                        shrink={true}
                        htmlFor={id}>

                        {labelText}
                    </InputLabel>)
                    : null
            }

            <Input
                {...inputProps}
                sx={getBaseSxStyle(styles, ['root', 'disabled', ...underlineKeys])}
                id={id}
            />

            {
                error
                    ? (<Clear sx={getBaseSxStyle(styles, ['feedback', 'labelRootError'])} />)
                    : success
                        ? (<Check sx={getBaseSxStyle(styles, ['feedback', 'labelRootSuccess'])} />)
                        : null
            }

        </FormControl>
    );
}

CustomInput.propTypes = {
    labelText: PropTypes.node,
    labelProps: PropTypes.object,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    error: PropTypes.bool,
    success: PropTypes.bool,
};
